<template lang="pug">
  .wrapper.px-0
    .card-form
      .card-list
        .card-item(v-bind:class="{ '-active' : isCardFlipped }")
          .card-item__side.-front
            .card-item__focus(v-bind:class="{'-active' : focusElementStyle }" v-bind:style='focusElementStyle' ref='focusElement')
            .card-item__cover
              img.card-item__bg(v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + currentCardBackground + '.jpeg'")
            .card-item__wrapper
              .card-item__top
                img.card-item__chip(src='https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/chip.png')
                .card-item__type
                  transition(name='slide-fade-up')
                    img.card-item__typeImg(v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + getCardType + '.png'" v-if='getCardType' v-bind:key='getCardType' alt='')
              label.card-item__number(for='cardNumber' ref='cardNumber')
                template(v-if="getCardType === 'amex'")
                  span(v-for='(n, $index) in amexCardMask' :key='$index')
                    transition(name='slide-fade-up')
                      .card-item__numberItem(v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''") *
                      .card-item__numberItem(:class="{ '-active' : n.trim() === '' }" :key='$index' v-else-if='cardNumber.length > $index')
                        | {{cardNumber[$index]}}
                      .card-item__numberItem(:class="{ '-active' : n.trim() === '' }" v-else='' :key='$index + 1') {{n}}
                template(v-else='')
                  span(v-for='(n, $index) in otherCardMask' :key='$index')
                    transition(name='slide-fade-up')
                      .card-item__numberItem(v-if="$index > 4 && $index < 15 && cardNumber.length > $index && n.trim() !== ''") *
                      .card-item__numberItem(:class="{ '-active' : n.trim() === '' }" :key='$index' v-else-if='cardNumber.length > $index')
                        | {{cardNumber[$index]}}
                      .card-item__numberItem(:class="{ '-active' : n.trim() === '' }" v-else='' :key='$index + 1') {{n}}
              .card-item__content
                label.card-item__info(for='cardName' ref='cardName')
                  .card-item__holder {{$t('payment.planner.cardName')}}
                  transition(name='slide-fade-up')
                    .card-item__name(v-if='cardName.length' key='1')
                      transition-group(name='slide-fade-right')
                        span.card-item__nameItem(v-for="(n, $index) in cardName.replace(/\s\s+/g, ' ')" v-if='$index === $index' v-bind:key='$index + 1') {{n}}
                        .card-item__name(v-else='' key='2') {{$t('payment.planner.fullName')}}
                .card-item__date(ref='cardDate')
                  label.card-item__dateTitle(for='cardMonth') {{$t('payment.planner.expires')}}
                  label.card-item__dateItem(for='cardMonth')
                    transition(name='slide-fade-up')
                      span(v-if='cardMonth' v-bind:key='cardMonth') {{cardMonth}}
                      span(v-else='' key='2') MM
                  |                   /
                  label.card-item__dateItem(for='cardYear')
                    transition(name='slide-fade-up')
                      span(v-if='cardYear' v-bind:key='cardYear') {{String(cardYear).slice(2,4)}}
                      span(v-else='' key='2') YY
          .card-item__side.-back
            .card-item__cover
              img.card-item__bg(v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + currentCardBackground + '.jpeg'")
            .card-item__band
            .card-item__cvv
              .card-item__cvvTitle CVV
              .card-item__cvvBand
                span(v-for='(n, $index) in cardCvv' :key='$index')
                  | *
              .card-item__type
                img.card-item__typeImg(v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + getCardType + '.png'" v-if='getCardType')
      v-form(ref='form' v-model='valid' lazy-validation='')
        .card-form__inner
          .card-input
            label.card-input__label(for='cardNumber') {{$t('payment.planner.cardNumber')}}
            v-text-field#cardNumber.card-input__input(maxlength="16" :rules='numberRules' required type='text' v-model='cardNumber' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardNumber' autocomplete='off' @keypress="isNumberChar($event)")
            <!--input#cardNumber.card-input__input(:rules='emailRules' required type='text' v-model='cardNumber' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardNumber' autocomplete='off')-->
          .card-form__row
            .card-form__col
              .card-form__group
                label.card-input__label(for='cardMonth') {{$t('payment.planner.expirationDate')}}
                v-select#cardMonth.card-input__input.-select(v-model='cardMonth' :items="monthList" v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardDate' :rules="[v => !!v || 'Item is required']" required='')
                v-select#cardYear.card-input__input.-select(v-model='cardYear' :items="yearList" v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardDate' :rules="[v => !!v || 'Item is required']" required='')
            .card-form__col.-cvv
              .card-input
                label.card-input__label(for='cardCvv') CVV
                v-text-field#cardCvv.card-input__input(:rules='cvvRules' required type='text' maxlength='3' v-model='cardCvv' v-on:focus='flipCard(true)' v-on:blur='flipCard(false)' autocomplete='off' @keypress="isNumber($event)")
          .card-input
            label.card-input__label(for='cardName') {{$t('payment.planner.cardName')}}
            v-text-field#cardName.card-input__input(maxlength="50" :rules='nameRules' required type='text' v-model='cardName' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardName' autocomplete='off')
          <!--.card-input-->
            <!--label.card-input__label(for='cardPhone') {{$t('payment.planner.userPhone')}}-->
            <!--v-text-field#cardPhone.card-input__input(maxlength="50" :rules='phoneRules' required v-model='phone' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardPhone' autocomplete='off' type="number")-->
          <!--.card-input-->
            <!--label.card-input__label(for='cardAddress') {{$t('payment.planner.userAddress')}}-->
            <!--v-text-field#cardAddress.card-input__input(maxlength="50" :rules='addressRules' required v-model='address' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardPhone' autocomplete='off' type="text")-->
          .card-input
            label.card-input__label(for='cardTypeDi') Tipo de documento de identidad
            v-select#cardCC.card-input__input(:rules='docTypeRules' :items="docsAvailable" return-object item-text='name' required v-model='docType' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='docType')
          .card-input
            label.card-input__label(for='cardCC') {{$t('payment.planner.ccNumber')}}
            v-text-field#cardCC.card-input__input(maxlength="16" :rules='ccRules' required type='text' v-model='cardCc' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardCC' autocomplete='off')
          .card-input
            label.card-input__label(for='cardMail') {{$t('payment.user.email')}}
            v-text-field#cardMail.card-input__input(maxlength="100" :rules='emailRules' required disabled=true type='text' v-model='cardMail' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardMail' autocomplete='off')
          .card-input
            label.card-input__label(for='cardAddress') {{$t('payment.user.userAddress')}}
            v-text-field#cardAddress.card-input__input(maxlength="100" :rules='addressRules' required type='text' v-model='cardAddress' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardAddress' autocomplete='off')
          .card-input
            label.card-input__label(for='cardCity') {{$t('payment.user.userCity')}}
            v-text-field#cardCity.card-input__input(maxlength="100" :rules='addressRules' required type='text' v-model='cardCity' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardCity' autocomplete='off')
          .card-input
            label.card-input__label(for='cardPhone') {{$t('payment.user.userPhone')}}
            v-text-field#cardPhone.card-input__input(:rules='phoneRules' required type='number' v-model='cardPhone' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardPhone' autocomplete='off')
      v-btn.btn-suscribe(color='green' @click="subscription" :loading="loading" :disabled="loading || loadingReferralCode || !docType || !cardAddress || !cardCity || !cardPhone || !cardNumber || !cardCc || !cardMonth || !cardYear || !cardCvv" )
        v-icon(small) mdi-checkbox-multiple-marked-outline
        | {{plan.title ? $t('payment.planner.subscribeTo') : $t('payment.planner.newCard')}}
      v-row.justify-center
        v-col(cols="12").text-center
          p Powered by
          v-img(:src="logo" max-width="100").mx-auto
      .text-center(v-if="plan.title")
        v-dialog(v-model="loading" persistent="" width="300")
          v-card(color="white" dark="")
            v-card-text
              | Por favor espere, su pago esta siendo procesado...
              v-progress-linear.mb-0(indeterminate="" color="primary")
</template>

<script>
  import axios from 'axios'
  import logo from '@/assets/logo_epayco.png'
  // import { _ } from 'vue-underscore'
  import Swal from 'sweetalert2'

  export default {
    name: 'CreditCardForm',
    props: {
      plan: {
        type: Object,
        default: () => ({
          best: false,
          heading: undefined,
          icon: undefined,
          title: undefined,
          text: undefined,
        }),
      },
    },
    // props: {
    //   token: undefined,
    // },

    data () {
      return {
        shopsList: [],
        collaboratorsList: [],
        localIp: '',
        docType: {},
        cardList: [],
        loading: false,
        monthList:
          [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12',
          ],
        yearList:
          [
            '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030',
          ],
        valid: true,
        currentCardBackground: Math.floor(Math.random() * 25 + 1), // just for fun :D
        cardPhone: '',
        cardAddress: '',
        cardCity: '',
        cardName: '',
        cardNumber: '',
        cardCc: '',
        cardMail: '',
        phone: '',
        address: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
        referralCode: '',
        referralTextState: '',
        minCardYear: new Date().getFullYear(),
        amexCardMask: '#### ###### #####',
        otherCardMask: '#### #### #### ####',
        cardNumberTemp: '',
        isCardFlipped: false,
        focusElementStyle: null,
        isInputFocused: false,
        loadingReferralCode: false,
        validCode: false,
        invalidCodeMessage: false,
        nameRules: [
          v => !!v || this.$t('payment.message.nameRequired'),
        ],
        phoneRules: [
          v => !!v || this.$t('payment.message.nameRequired'),
          v => (v && v.length >= 7) || this.$t('payment.message.phoneLength'),
        ],
        addressRules: [
          v => !!v || this.$t('payment.message.nameRequired'),
        ],
        numberRules: [
          v => !!v || this.$t('payment.message.cardNumberRequired'),
        ],
        ccRules: [
          v => !!v || this.$t('payment.message.ccDocumentRequired'),
        ],
        cvvRules: [
          v => !!v || this.$t('payment.message.ccvCodeRequired'),
        ],
        emailRules: [
          v => !!v || this.$t('payment.message.emailRequired'),
          v => /.+@.+\..+/.test(v) || this.$t('payment.message.emailIncorrect'),
        ],
        docTypeRules: [
          v => !!v || 'Tipo de documento es requerido',
        ],
        logo,
      }
    },
    computed: {
      getCardType () {
        const number = this.cardNumber
        let re = new RegExp('^4')
        if (number.match(re) != null) return 'visa'

        re = new RegExp('^(34|37)')
        if (number.match(re) != null) return 'amex'

        re = new RegExp('^5[1-5]')
        if (number.match(re) != null) return 'mastercard'

        re = new RegExp('^6011')
        if (number.match(re) != null) return 'discover'

        re = new RegExp('^9792')
        if (number.match(re) != null) return 'troy'

        return 'visa' // default type
      },
      generateCardNumberMask () {
        return this.getCardType === 'amex' ? this.amexCardMask : this.otherCardMask
      },
      minCardMonth () {
        if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1
        return 1
      },
      docsAvailable () {
        let docs = []
        // if (this.$store.state.users.profile.direction.country === 'Colombia' || !this.$store.state.users.profile.direction.country) {
        // CC,CE,PPN, SSN(Social security number),LIC(NOSE),NIT,DNI(DOCUMENTO NACIONAL DE IDENTIDAD)
        docs = [
          { name: 'CC', value: 'CC' },
          { name: 'CE', value: 'CE' },
          { name: 'PPN', value: 'PPN' },
          { name: 'NIT', value: 'NIT' },
          { name: 'SSN', value: 'SSN' },
          { name: 'LIC', value: 'LIC' },
          { name: 'DNI', value: 'DNI' },
        ]
        /* } else if (this.$store.state.users.profile.direction.country === 'México') {
          docs = [{ name: 'Cedula de ciudadania', value: 'CC' }, { name: 'Cedula de extranjeria', value: 'CE' }]
        } */
        return docs
      },
    },
    watch: {
      cardYear () {
        if (this.cardMonth < this.minCardMonth) {
          this.cardMonth = ''
        }
      },
    },
    mounted () {
      this.shopsList = this.$store.getters['shops/getItems']
      this.$store.dispatch('users/getCollaborators').then(res => {
        this.collaboratorsList = res
      })
      axios.get('https://api.ipify.org?format=json')
        .then(response => {
          this.localIp = response.data.ip
        })
      this.$store.dispatch('payment/getCustomerData').then(res => {
        if (res) {
          this.cardList = res.cardList.reverse()
        }
      })
      window.scrollTo(0, 0)
      this.cardName = this.$store.state.users.profile.name + ' ' + this.$store.state.users.profile.last_name
      this.cardMail = this.$store.state.users.user.email
      if (this.$store.state.users.profile.phone) {
        this.cardPhone = this.$store.state.users.profile.phone
      }
      if (this.$store.state.users.profile.direction && this.$store.state.users.profile.direction.city) {
        this.cardCity = this.$store.state.users.profile.direction.city
      }
      if (this.$store.state.users.profile.direction && this.$store.state.users.profile.direction.address) {
        this.cardAddress = this.$store.state.users.profile.direction.city + ' ' + this.$store.state.users.profile.direction.address // + ' ' + this.$store.state.users.profile.direction.street
      }
      if (this.$store.state.users.profile.referralOwnerCode) {
        this.$store.dispatch('referrals/getCodeOfReferralOwner', this.$store.state.users.profile.referralOwnerCode).then(res => {
          if (res) {
            this.referralCode = res
            this.validCode = true
            this.referralTextState = 'codigo valido'
          }
        })
      }
      this.cardNumberTemp = this.otherCardMask
      document.getElementById('cardNumber').focus()
      if (this.plan.title) {
        this.$store.dispatch('payment/getCardData').then(res => {
          if (res) {
            this.cardNumber = res.card.mask
            this.cardYear = res.card.exp_year
            this.cardMonth = res.card.exp_month
            this.cardName = res.person.holderName
            this.cardMail = res.person.emailUser
            this.cardCc = res.person.doc_number
            this.cardCvv = ''
            this.docType = res.person.doc_type.name || 'Cedula de ciudadania' // falta poner condicional de pais
          }
        })
      }
    },
    methods: {
      isNumber (evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      isNumberChar (evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if (charCode === 42) {
          return true
        }
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      setDataNotification (icon, text) {
        const vm = this
        vm.loading = false
        Swal.fire(
          text,
          '',
          icon,
        ).then(() => {
          if (icon === 'success' && vm.plan.title) {
            vm.$router.push('/dashboard/profile')
          }
        })
      },
      subscription () {
        const val = this.$refs.form.validate()
        const vm = this
        if (val) {
          let cont = 0
          let ban = true
          vm.cardNumber = vm.cardNumber.trim()
          const sizeCard = vm.cardNumber.length
          const number1 = vm.cardNumber.slice(0, 6)
          const number2 = vm.cardNumber.slice(-4)
          const sizellenar = sizeCard - 10
          let llenar = ''
          for (let i = 0; i < sizellenar; i++) {
            llenar = llenar + '*'
          }
          const newNumber = number1 + llenar + number2
          while (cont < vm.cardList.length) {
            const numberCompare = vm.cardList[cont].data.card.mask
            if (numberCompare === newNumber) {
              ban = false
            }
            cont++
          }
          if (!ban) {
            vm.setDataNotification('error', vm.$t('payment.message.previouslyCard'))
            return
          }
          vm.loading = true
          const cardData = {
            'card[number]': vm.cardNumber.toString(),
            'card[exp_year]': vm.cardYear.toString(),
            'card[exp_month]': vm.cardMonth.toString(),
            'card[cvc]': vm.cardCvv.toString(),
          }
          // console.log(vm.docType)
          const userData = {
            holderName: vm.cardName,
            emailUser: vm.cardMail,
            doc_type: vm.docType,
            doc_number: vm.cardCc,
          }
          const data = {
            dataCard: cardData,
            dataUser: userData,
          }
          vm.$store.dispatch('payment/tokenization', data).then(res => {
            const userData = {
              userEmail: vm.cardMail,
              address: vm.cardAddress,
              phone: vm.cardPhone,
              city: vm.cardCity,
            }
            if (res) {
              vm.$store.dispatch('payment/createCustomer', userData).then(res => {
                if (vm.plan.title) {
                  if (res) {
                    const dataSubscription = {
                      id_plan: vm.plan.id_plan,
                      restrictions: vm.plan.restrictions,
                      shops: vm.shopsList,
                      collaborators: vm.collaboratorsList,
                    }
                    vm.$store.dispatch('payment/createSubscription', dataSubscription).then(res => {
                      if (res) {
                        // console.log(res, 'la respuesta de la subs')
                        if (res.status) {
                          const dataSubscription = {
                            doc_number: vm.cardCc,
                            doc_type: vm.docType.value,
                            ip: vm.localIp,
                            id_plan: vm.plan.id_plan,
                            shops: vm.shopsList,
                            collaborators: vm.collaboratorsList,
                          }
                          vm.$store.dispatch('payment/paySubscription', dataSubscription).then(async res => {
                            vm.loading = false
                            // console.log(res, 'la respuesta de la subs 2')
                            if (res) {
                              vm.loadingNew = false
                              if (res.status === 'active') {
                                vm.setDataNotification('success', vm.$t('payment.message.successProcess'))
                              } else if (res.status === 'canceled') {
                                vm.setDataNotification('error', vm.$t('payment.message.errorProcessCard'))
                              } else if (res.status === 'pending') {
                                vm.setDataNotification('info', vm.$t('payment.message.pendingPayment'))
                              } else {
                                vm.setDataNotification('error', vm.$t('payment.message.inactiveSubscription'))
                              }
                            }
                          })
                        } else {
                          // console.log(res)
                          vm.setDataNotification('error', vm.$t('payment.message.errorProcessSubscription'))
                          vm.loading = false
                        }
                      } else {
                        // console.log(res)
                        vm.setDataNotification('error', vm.$t('payment.message.errorProcessSubscription'))
                        vm.loading = false
                      }
                    }, rej => {
                      // console.log(res)
                      vm.setDataNotification('error', vm.$t('payment.message.errorProcessSubscription'))
                      vm.loading = false
                    })
                  } else {
                    vm.setDataNotification('error', vm.$t('payment.message.clientProcessError'))
                    vm.loading = false
                  }
                } else {
                  vm.setDataNotification('success', vm.$t('payment.message.successProcess'))
                  setTimeout(() => {
                    vm.loading = false
                    vm.$router.back()
                    // vm.$router.push('create-shop')
                  }, 4000)
                }
              }, rej => {
                vm.setDataNotification('error', vm.$t('payment.message.clientProcessError'))
                vm.loading = false
              })
            } else {
              vm.setDataNotification('error', vm.$t('payment.message.processCardError'))
              vm.loading = false
            }
          }, rej => {
            vm.setDataNotification('error', vm.$t('payment.message.processCardError'))
            vm.loading = false
          })
        } else {
          vm.setDataNotification('error', vm.$t('payment.message.addFormData'))
          vm.loading = false
        }
      },
      flipCard (status) {
        this.isCardFlipped = status
      },
      focusInput (e) {
        this.isInputFocused = true
      },
      blurInput () {
        const vm = this
        setTimeout(() => {
          if (!vm.isInputFocused) {
            vm.focusElementStyle = null
          }
        }, 300)
        vm.isInputFocused = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .btn-suscribe {
    font-size: 20px;
    width: 100%;
    margin-top: 10px;
  }
  .v-messages__message {
    padding-top: 5px !important;
  }
  .card-input__input.-select[data-v-259889de] {
    -webkit-appearance: none;
    background-image: none !important;
    background-size: 12px;
    background-position: 90% center;
    background-repeat: no-repeat;
    padding-right: 10px !important;
  }
  @import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:400,500,600,700|Source+Sans+Pro:400,600,700&display=swap");
  body {
    background: #ddeefc;
    font-family: "Source Sans Pro", sans-serif;
    font-size: 16px;
  }
  * {
    box-sizing: border-box;
    &:focus {
      outline: none;
    }
  }
  .wrapper {
    min-height: 100vh;
    display: flex;
    padding: 50px 15px;
    @media screen and (max-width: 700px), (max-height: 500px) {
      flex-wrap: wrap;
      flex-direction: column;
    }
  }

  .card-form {
    max-width: 570px;
    margin: auto;
    width: 100%;

    @media screen and (max-width: 576px) {
      margin: 0 auto;
    }

    &__inner {
      background: #fff;
      // box-shadow: 3px 13px 30px 0px rgba(21, 34, 67, 0.2);
      box-shadow: 0 30px 60px 0 rgba(90, 116, 148, 0.4);
      border-radius: 10px;
      padding: 35px;
      padding-top: 180px;

      @media screen and (max-width: 480px) {
        padding: 25px;
        padding-top: 165px;
      }
      @media screen and (max-width: 360px) {
        padding: 15px;
        padding-top: 165px;
      }
    }

    &__row {
      display: flex;
      align-items: flex-start;
      @media screen and (max-width: 480px) {
        flex-wrap: wrap;
      }
    }

    &__col {
      flex: auto;
      margin-right: 35px;

      &:last-child {
        margin-right: 0;
      }

      @media screen and (max-width: 480px) {
        margin-right: 0;
        flex: unset;
        width: 100%;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &.-cvv {
        max-width: 150px;
        @media screen and (max-width: 480px) {
          max-width: initial;
        }
      }
    }

    &__group {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;

      .card-input__input {
        flex: 1;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &__button {
      width: 100%;
      height: 55px;
      background: #2364d2;
      border: none;
      border-radius: 5px;
      font-size: 22px;
      font-weight: 500;
      font-family: "Source Sans Pro", sans-serif;
      box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
      color: #fff;
      margin-top: 20px;
      cursor: pointer;

      @media screen and (max-width: 480px) {
        margin-top: 10px;
      }
    }
  }

  .card-item {
    max-width: 430px;
    height: 270px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    z-index: 2;
    width: 100%;

    @media screen and (max-width: 480px) {
      max-width: 310px;
      height: 220px;
      width: 90%;
    }

    @media screen and (max-width: 360px) {
      height: 180px;
    }

    &.-active {
      .card-item__side {
        &.-front {
          transform: perspective(1000px) rotateY(180deg) rotateX(0deg)
          rotateZ(0deg);
        }
        &.-back {
          transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
          // box-shadow: 0 20px 50px 0 rgba(81, 88, 206, 0.65);
        }
      }
    }

    &__focus {
      position: absolute;
      z-index: 3;
      border-radius: 5px;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
      opacity: 0;
      pointer-events: none;
      overflow: hidden;
      border: 2px solid rgba(255, 255, 255, 0.65);

      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: rgb(8, 20, 47);
        height: 100%;
        border-radius: 5px;
        filter: blur(25px);
        opacity: 0.5;
      }

      &.-active {
        opacity: 1;
      }
    }

    &__side {
      border-radius: 15px;
      overflow: hidden;
      // box-shadow: 3px 13px 30px 0px rgba(11, 19, 41, 0.5);
      box-shadow: 0 20px 60px 0 rgba(14, 42, 90, 0.55);
      transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
      transform-style: preserve-3d;
      transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
      backface-visibility: hidden;
      height: 100%;

      &.-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        transform: perspective(2000px) rotateY(-180deg) rotateX(0deg) rotate(0deg);
        z-index: 2;
        padding: 0;
        // background-color: #2364d2;
        // background-image: linear-gradient(
        //   43deg,
        //   #4158d0 0%,
        //   #8555c7 46%,
        //   #2364d2 100%
        // );
        height: 100%;

        .card-item__cover {
          transform: rotateY(-180deg)
        }
      }
    }
    &__bg {
      max-width: 100%;
      display: block;
      max-height: 100%;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    &__cover {
      height: 100%;
      background-color: #1c1d27;
      position: absolute;
      height: 100%;
      background-color: #1c1d27;
      left: 0;
      top: 0;
      width: 100%;
      border-radius: 15px;
      overflow: hidden;
      &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(6, 2, 29, 0.45);
      }
    }

    &__top {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 40px;
      padding: 0 10px;

      @media screen and (max-width: 480px) {
        margin-bottom: 25px;
      }
      @media screen and (max-width: 360px) {
        margin-bottom: 15px;
      }
    }

    &__chip {
      width: 60px;
      @media screen and (max-width: 480px) {
        width: 50px;
      }
      @media screen and (max-width: 360px) {
        width: 40px;
      }
    }

    &__type {
      height: 45px;
      position: relative;
      display: flex;
      justify-content: flex-end;
      max-width: 100px;
      margin-left: auto;
      width: 100%;

      @media screen and (max-width: 480px) {
        height: 40px;
        max-width: 90px;
      }
      @media screen and (max-width: 360px) {
        height: 30px;
      }
    }

    &__typeImg {
      max-width: 100%;
      object-fit: contain;
      max-height: 100%;
      object-position: top right;
    }

    &__info {
      color: #fff;
      width: 100%;
      max-width: calc(100% - 85px);
      padding: 10px 15px;
      font-weight: 500;
      display: block;

      cursor: pointer;

      @media screen and (max-width: 480px) {
        padding: 10px;
      }
    }

    &__holder {
      opacity: 0.7;
      font-size: 13px;
      margin-bottom: 6px;
      @media screen and (max-width: 480px) {
        font-size: 12px;
        margin-bottom: 5px;
      }
    }

    &__wrapper {
      font-family: "Source Code Pro", monospace;
      padding: 25px 15px;
      position: relative;
      z-index: 4;
      height: 100%;
      text-shadow: 7px 6px 10px rgba(14, 42, 90, 0.8);
      user-select: none;
      @media screen and (max-width: 480px) {
        padding: 20px 10px;
      }
    }

    &__name {
      font-size: 18px;
      line-height: 1;
      white-space: nowrap;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-transform: uppercase;
      @media screen and (max-width: 480px) {
        font-size: 16px;
      }
    }
    &__nameItem {
      display: inline-block;
      min-width: 8px;
      position: relative;
    }

    &__number {
      font-weight: 500;
      line-height: 1;
      color: #fff;
      font-size: 27px;
      margin-bottom: 35px;
      display: inline-block;
      padding: 10px 15px;
      cursor: pointer;

      @media screen and (max-width: 480px) {
        font-size: 21px;
        margin-bottom: 15px;
        padding: 10px 10px;
      }

      @media screen and (max-width: 360px) {
        font-size: 19px;
        margin-bottom: 10px;
        padding: 10px 10px;
      }
    }

    &__numberItem {
      width: 16px;
      display: inline-block;
      &.-active {
        width: 30px;
      }

      @media screen and (max-width: 480px) {
        width: 13px;

        &.-active {
          width: 16px;
        }
      }

      @media screen and (max-width: 360px) {
        width: 12px;

        &.-active {
          width: 8px;
        }
      }
    }

    &__content {
      color: #fff;
      display: flex;
      align-items: flex-start;
    }

    &__date {
      flex-wrap: wrap;
      font-size: 18px;
      margin-left: auto;
      padding: 10px;
      display: inline-flex;
      width: 80px;
      white-space: nowrap;
      flex-shrink: 0;
      cursor: pointer;

      @media screen and (max-width: 480px) {
        font-size: 16px;
      }
    }

    &__dateItem {
      position: relative;
      span {
        width: 22px;
        display: inline-block;
      }
    }

    &__dateTitle {
      opacity: 0.7;
      font-size: 13px;
      padding-bottom: 6px;
      width: 100%;

      @media screen and (max-width: 480px) {
        font-size: 12px;
        padding-bottom: 5px;
      }
    }
    &__band {
      background: rgba(0, 0, 19, 0.8);
      width: 100%;
      height: 50px;
      margin-top: 30px;
      position: relative;
      z-index: 2;
      @media screen and (max-width: 480px) {
        margin-top: 20px;
      }
      @media screen and (max-width: 360px) {
        height: 40px;
        margin-top: 10px;
      }
    }

    &__cvv {
      text-align: right;
      position: relative;
      z-index: 2;
      padding: 15px;
      .card-item__type {
        opacity: 0.7;
      }

      @media screen and (max-width: 360px) {
        padding: 10px 15px;
      }
    }
    &__cvvTitle {
      padding-right: 10px;
      font-size: 15px;
      font-weight: 500;
      color: #fff;
      margin-bottom: 5px;
    }
    &__cvvBand {
      height: 45px;
      background: #fff;
      margin-bottom: 30px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
      color: #1a3b5d;
      font-size: 18px;
      border-radius: 4px;
      box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);

      @media screen and (max-width: 480px) {
        height: 40px;
        margin-bottom: 20px;
      }

      @media screen and (max-width: 360px) {
        margin-bottom: 15px;
      }
    }
  }

  .card-list {
    margin-bottom: -130px;

    @media screen and (max-width: 480px) {
      margin-bottom: -120px;
    }
  }

  .card-input {
    margin-bottom: 20px;
    &__label {
      font-size: 14px;
      margin-bottom: 5px;
      font-weight: 500;
      color: #1a3b5d;
      width: 100%;
      display: block;
      user-select: none;
    }
    &__input {
      width: 100%;
      height: 50px;
      border-radius: 5px;
      box-shadow: none;
      border: 1px solid #ced6e0;
      transition: all 0.3s ease-in-out;
      font-size: 18px;
      padding: 5px 15px;
      background: none;
      color: #1a3b5d;
      font-family: "Source Sans Pro", sans-serif;

      &:hover,
      &:focus {
        border-color: #3d9cff;
      }

      &:focus {
        box-shadow: 0px 10px 20px -13px rgba(32, 56, 117, 0.35);
      }
      &.-select {
        -webkit-appearance: none;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAeCAYAAABuUU38AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUxJREFUeNrM1sEJwkAQBdCsngXPHsQO9O5FS7AAMVYgdqAd2IGCDWgFnryLFQiCZ8EGnJUNimiyM/tnk4HNEAg/8y6ZmMRVqz9eUJvRaSbvutCZ347bXVJy/ZnvTmdJ862Me+hAbZCTs6GHpyUi1tTSvPnqTpoWZPUa7W7ncT3vK4h4zVejy8QzM3WhVUO8ykI6jOxoGA4ig3BLHcNFSCGqGAkig2yqgpEiMsjSfY9LxYQg7L6r0X6wS29YJiYQYecemY+wHrXD1+bklGhpAhBDeu/JfIVGxaAQ9sb8CI+CQSJ+QmJg0Ii/EE2MBiIXooHRQhRCkBhNhBcEhLkwf05ZCG8ICCOpk0MULmvDSY2M8UawIRExLIQIEgHDRoghihgRIgiigBEjgiFATBACAgFgghEwSAAGgoBCBBgYAg5hYKAIFYgHBo6w9RRgAFfy160QuV8NAAAAAElFTkSuQmCC');
        background-size: 12px;
        background-position: 90% center;
        background-repeat: no-repeat;
        padding-right: 30px;
      }
    }
  }

  .slide-fade-up-enter-active {
    transition: all 0.25s ease-in-out;
    transition-delay: 0.1s;
    position: relative;
  }
  .slide-fade-up-leave-active {
    transition: all 0.25s ease-in-out;
    position: absolute;
  }
  .slide-fade-up-enter {
    opacity: 0;
    transform: translateY(15px);
    pointer-events: none;
  }
  .slide-fade-up-leave-to {
    opacity: 0;
    transform: translateY(-15px);
    pointer-events: none;
  }

  .slide-fade-right-enter-active {
    transition: all 0.25s ease-in-out;
    transition-delay: 0.1s;
    position: relative;
  }
  .slide-fade-right-leave-active {
    transition: all 0.25s ease-in-out;
    position: absolute;
  }
  .slide-fade-right-enter {
    opacity: 0;
    transform: translateX(10px) rotate(45deg);
    pointer-events: none;
  }
  .slide-fade-right-leave-to {
    opacity: 0;
    transform: translateX(-10px) rotate(45deg);
    pointer-events: none;
  }
  .github-btn {
    position: absolute;
    right: 40px;
    bottom: 50px;
    text-decoration: none;
    padding: 15px 25px;
    border-radius: 4px;
    box-shadow: 0px 4px 30px -6px rgba(36, 52, 70, 0.65);
    background: #24292e;
    color: #fff;
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 16px;
    text-align: center;
    transition: all .3s ease-in-out;

    @media screen and (min-width: 500px) {
      &:hover {
        transform: scale(1.1);
        box-shadow: 0px 17px 20px -6px rgba(36, 52, 70, 0.36);
      }
    }

    @media screen and (max-width: 700px) {
      position: relative;
      bottom: auto;
      right: auto;
      margin-top: 20px;

      &:active {
        transform: scale(1.1);
        box-shadow: 0px 17px 20px -6px rgba(36, 52, 70, 0.36);
      }
    }
  }
</style>
